module.exports = __webpack_public_path__ + "static/media/PSLxText Bold.8bfae045.ttf";